export const fmtMXN = (v) => {
  const n = Number(v || 0);
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(n);
};

export const fmtPct = (v) => {
  const n = Number(v || 0) * 100;
  return `${n.toFixed(2)}%`;
};

export const HERMOSILLO_TZ = 'America/Hermosillo';

export const nowInHermosillo = () => new Date(new Date().toLocaleString('en-US', { timeZone: HERMOSILLO_TZ }));

export const currentYearMonth = () => {
  const d = nowInHermosillo();
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
};

export const fmtDateMX = (iso) => {
  if (!iso) return '';
  const dateOnly = String(iso).slice(0, 10);
  const match = dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (match) {
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }

  return String(iso);
};

export const fmtDateTimeMX = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat('es-MX', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', timeZone: HERMOSILLO_TZ,
    }).format(d);
  } catch { return iso; }
};

export const MONTH_NAMES = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre',
];

export const STATUS_LABEL = {
  borrador: 'Borrador',
  datos_incompletos: 'Datos incompletos',
  con_diferencias: 'Con diferencias',
  listo_revision: 'Listo para revisión',
  revisado: 'Revisado',
  presentado_sat: 'Presentado en SAT',
};

export const STATUS_COLOR = {
  borrador: 'bg-muted text-muted-foreground',
  datos_incompletos: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  con_diferencias: 'bg-red-500/15 text-red-700 dark:text-red-400',
  listo_revision: 'bg-blue-500/15 text-blue-700 dark:text-blue-400',
  revisado: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  presentado_sat: 'bg-primary/15 text-primary',
};
